import { render, staticRenderFns } from "./Nevi.vue?vue&type=template&id=72ca4eac&scoped=true&"
import script from "./Nevi.vue?vue&type=script&lang=js&"
export * from "./Nevi.vue?vue&type=script&lang=js&"
import style0 from "./Nevi.vue?vue&type=style&index=0&id=72ca4eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca4eac",
  null
  
)

export default component.exports